import {
  IconNameEnum,
  useActivitiesStyles,
  useModuleBEM,
} from "@b2bportal/core-themes";
import {
  CoreActivitiesComponent,
  type PlatformComponentProps,
} from "@b2bportal/core-types";
import { ActivitySearch, useHomePageActivitySearch } from "@tenant/activities";
import { Icon } from "@tenant/ui";
import clsx from "clsx";
import defaultStyles from "./HomePageActivitySearch.module.scss";
import {
  ActivitiesRawEventName,
  useEmitActivitiesRawEventOnce,
} from "~core-activities/tracking";

export type HomePageActivitySearchComponentProps = PlatformComponentProps;
export const HomePageActivitySearch = ({
  children,
  className,
}: HomePageActivitySearchComponentProps) => {
  const COMPONENT_KEY = CoreActivitiesComponent.HomePageActivitySearch;
  const styles = useActivitiesStyles(COMPONENT_KEY, defaultStyles);
  const [block, cn] = useModuleBEM(styles, COMPONENT_KEY);

  const { handlers, text } = useHomePageActivitySearch();

  useEmitActivitiesRawEventOnce({
    name: ActivitiesRawEventName.ActivitySearchLoaded,
  });

  return (
    <div className={clsx(block, className)}>
      <div className={cn("search")}>
        <ActivitySearch />
      </div>
      <div className={cn("search-entry")}>
        <button
          onClick={() => handlers.handleMobileRedirect()}
          className={cn("start-search-button")}
        >
          <Icon iconName={IconNameEnum.search} className={cn("button-icon")} />
          {text.mobileButtonLabel}
        </button>
      </div>
      {children}
    </div>
  );
};
